import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import {
  getWorkFlowAutomationStoppedInstances,
  getWorkFlowAutomationStoppedInstancesActions,
} from 'services/workflowAutomation/workflowAutomationRuleServices';
import { paginationDropdownOptions } from 'constants/dropdownOptions';
import { handlePageNumberInPagination } from 'common/pagination';
import { useUserDetailsContext } from 'context/userDetailsContext';

export const useAutomationStoppedInstance = (_pageSize = 10, filter) => {
  const userDetails = useUserDetailsContext();
  const [stoppedAutomationInstances, setStoppedAutomationInstances] = useState([]);
  const [isForward, setIsForward] = useState(true);
  const [pageSize, setpageSize] = useState(userDetails?.firmDetails?.pagination_preference?.automation_stopped_instance?.self ?? _pageSize);
  const { automationId } = useParams();

  const next_Token = stoppedAutomationInstances?.next_token;
  const transition_Token = stoppedAutomationInstances?.transition_token;
  const list = stoppedAutomationInstances?.automation_stopped_instance || [];

  const hasNext = next_Token === null && isForward;
  const hasPrevious = transition_Token === null || (transition_Token && next_Token === null && !isForward);

  const fetchNext = () => {
    setIsForward(true);
    listStoppedAutomationInstances(pageSize, !isForward ? transition_Token : next_Token, 'forward');
  };

  const fetchPrev = () => {
    setIsForward(false);
    listStoppedAutomationInstances(pageSize, !isForward ? transition_Token : next_Token, 'reverse');
  };

  const onPageChange = (e) => {
    setpageSize(e.value);
    listStoppedAutomationInstances(e.value, '', 'forward');
    setIsForward(false);
    handlePageNumberInPagination(userDetails, 'automation_stopped_instance', '', 'self', e.value);
  };

  const paginatorTemplate = {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: () => {
      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
            Item Per Page
          </span>
          <Dropdown value={pageSize} options={paginationDropdownOptions} onChange={onPageChange} />
        </React.Fragment>
      );
    },
    NextPageLink: ({ iconClassName }) => {
      return (
        <Button onClick={fetchNext} disabled={hasNext} className={'p-paginator-next p-paginator-element p-link'} icon={iconClassName} />
      );
    },
    PrevPageLink: ({ iconClassName }) => {
      return (
        <Button onClick={fetchPrev} disabled={hasPrevious} className={'p-paginator-next p-paginator-element p-link'} icon={iconClassName} />
      );
    },
  };

  const listStoppedAutomationInstances = (pageLimit, pagination_token, pagination_direction) => {
    getWorkFlowAutomationStoppedInstances(automationId, pageLimit, pagination_token, pagination_direction, filter)
      .then((res) => {
        setStoppedAutomationInstances(res?.data);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  const listStoppedAutomationInstancesActions = () => {
    return getWorkFlowAutomationStoppedInstancesActions(automationId);
  };

  useEffect(() => {
    automationId && listStoppedAutomationInstances();
  }, [filter]);

  return {
    listStoppedAutomationInstances,
    listStoppedAutomationInstancesActions,
    stoppedAutomationInstances: list,
    pageSize,
    paginatorTemplate,
  };
};
